import CombinePacks from 'components/combine/CombinePacks';
import CombinePrizes from 'components/combine/CombinePrizes';
import { useLocation } from 'react-router-dom';

const ActiveItemCombine = () => {
  const {pathname} = useLocation();

  if (pathname.includes("/prizes")) {
    return <CombinePrizes />
  } else if(pathname.includes("/inventory/card-packs")) {
    return <CombinePacks />
  } else return null

}

export default ActiveItemCombine;
